import styled from "styled-components";

export const Container = styled.section`
  margin-top: 12rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  .button {
    display: inline-block;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    background-color: var(--green); /* #00BFFF */
    color: #fff;
    font-weight: 800;
    font-size: 2rem;
    text-decoration: none;
    margin-top: 1.5rem;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(0, 191, 255, 0.2);
  }

  .button:hover,
  .button:focus {
    background-color: #00a7cc;
    box-shadow: 0 6px 15px rgba(0, 191, 255, 0.4);
    text-decoration: none;
    color: #fff;
  }

  h2 {
    display: inline-block;
    margin-bottom: 2rem;
    font-size: 5rem;
    margin-top: 0rem;
    color: var(--green);
  }

  h3 {
    margin-top: 2rem;
    color: var(--green);
    font-size: 2rem;
  }

  h4 {
    font-size: 1.8rem;
    font-weight: bold;
    margin-top: 1.4rem;
  }

  .education {
    text-align: center;
  }

  p {
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    font-weight: 500;
    line-height: 2.8rem;
    margin-top: 0.8rem;
    word-break: break-word;
  }

  .hard-skills {
    margin-top: 1.6rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.8rem;
  }

  .hability {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 3.4rem;
    }
  }

  .about-image {
    text-align: center;

    img {
      margin-top: 2rem;
      width: 75%;
      filter: grayscale(0);
      transition: filter 0.5s;
      &:hover {
        cursor: pointer;
        filter: grayscale(0);
      }
    }
  }

  /* Tablet */
  @media (max-width: 960px) {
    display: block;
    text-align: center;

    .hard-skills {
      justify-content: center;
    }

    .about-image {
      display: flex;
      justify-content: center;

      img {
        margin-top: 2rem;
        width: 100%;
      }
    }
  }

  /* Mobile */
  @media only screen and (max-width: 480px) {
    .about-image {
      max-width: 100%;
      margin-top: 4rem;

      img {
        margin-top: 2rem;
        width: 100%;
      }
    }

    p {
      font-size: 1.6rem;
      line-height: 2.5rem;
    }

    h3, h4 {
      font-size: 1.6rem;
    }

    .button {
      font-size: 1.6rem;
      padding: 0.8rem 1.2rem;
    }
  }
`;
